import { render, staticRenderFns } from "./DeletePopup.vue?vue&type=template&id=71c007dc&scoped=true"
import script from "./DeletePopup.vue?vue&type=script&lang=ts"
export * from "./DeletePopup.vue?vue&type=script&lang=ts"
import style0 from "./DeletePopup.vue?vue&type=style&index=0&id=71c007dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c007dc",
  null
  
)

export default component.exports